// extracted by mini-css-extract-plugin
module.exports = {"dangerous":"index_dangerous_2kprc","green":"index_green_3WIcm","yellow":"index_yellow_3PUoa","red":"index_red_3mLoa"};